import ChoiceCardsList from './ChoiceCardsList';
import ToggleCardsList from './ToggleCardsList';
import React from 'react';

const TypeSelector = ({
  stepType,
  cards,
  headingLevel,
  storage,
  setStorage,
  setStepNumber,
}) => {
  switch (stepType) {
    case 'choice':
      return (
        <ChoiceCardsList
          cards={cards}
          headingLevel={headingLevel}
          setStepNumber={setStepNumber}
          setStorage={setStorage}
          storage={storage}
        />
      );
    case 'toggle':
      return (
        <ToggleCardsList
          cards={cards}
          headingLevel={headingLevel}
          setStepNumber={setStepNumber}
          setStorage={setStorage}
          storage={storage}
        />
      );
    default:
      return null;
  }
};

export default TypeSelector;
